import { createClient } from "@supabase/supabase-js";
import { emitToast } from "../components/Toast";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Faltam VITE_SUPABASE_URL e/ou VITE_SUPABASE_ANON_KEY no .env.local"
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

// Instrumentação debug — sem PII, só nomes de eventos
supabase.auth.onAuthStateChange((event, session) => {
  if (import.meta.env.DEV) {
    console.debug("[supabase.auth]", event, session ? "session=ok" : "session=null");
  }
  // Avisa user quando sessão expira sem ele ter feito nada
  if (event === "TOKEN_REFRESHED" && !session) {
    emitToast("warning", "Sessão expirou. Faça login novamente.");
  }
});
